angular
	.module 'App.Component'
	.component 'tableHeader',
		{
			templateUrl: '@component/table/table-header/table-header.view.html'
			controller: 'TableHeaderComponent'
			controllerAs: 'tableHeader'
			bindings:
				filterDTO: '<?filterDto'
				label: '<'
				property: '<?'
				onSort: '&?'
		}

###
@param {string} label
@param {string} property - Property for column
@param {FilterDTO} filterDTO - FilterDTO instance to use for current sorting information
@param {callback} [onChange]
###
class TableHeaderComponent extends AbstractController
	@register()

	initialize: ->
		@hasSort = @onSort?

	sort: ->
		if @property == @filterDTO.sortProperty && @filterDTO.sortDirection == 'DESC'
			@filterDTO.sortDirection = 'ASC'
		else
			@filterDTO.sortDirection = 'DESC'

		@filterDTO.sortProperty = @property

		@onSort({property: @filterDTO.sortProperty, direction: @filterDTO.sortDirection})
